var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    {
      staticClass: "my-4",
      attrs: {
        cols: _vm.quizAnswersColumnsAnchor ? 6 : 12,
        lg: _vm.quizAnswersColumnsAnchor ? _vm.quizAnswersColumnsAnchor : 12
      }
    },
    [
      _c(
        "span",
        {
          class: {
            "answer-box": true,
            "quiz-answer-selected": _vm.itemSelected,
            clickable: !_vm.readOnly
          },
          attrs: { white: "" },
          on: {
            click: function($event) {
              !_vm.readOnly ? _vm.$emit("elementSelected") : null
            }
          }
        },
        [_vm._v(_vm._s(_vm.answer))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3954e6b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3954e6b9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/quiz/ClinicHistoryQuizAnswer.vue
// module id = 3061
// module chunks = 32 63